import { lazy } from "react";

// project-imports
import MainLayout from "layout/MainLayout";
import CommonLayout from "layout/CommonLayout";
import Loadable from "components/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import InstrumentsPage from "pages/instruments/InstrumentsPage";

const MaintenanceError = Loadable(
	lazy(() => import("pages/maintenance/error/404"))
);
const MaintenanceError500 = Loadable(
	lazy(() => import("pages/maintenance/error/500"))
);
const MaintenanceUnderConstruction = Loadable(
	lazy(() => import("pages/maintenance/under-construction/under-construction"))
);

const DashboardPage = Loadable(
	lazy(() => import("pages/Accounts/AccountsPage"))
);
const OrdersPage = Loadable(lazy(() => import("pages/orders/OrdersPage")));
const MimicSettingsPage = Loadable(
	lazy(() => import("pages/mimic-settings/MimicSettingsPage"))
);

const ConnectAdmin = Loadable(
	lazy(() => import("pages/connect-admin/ConnectAdminPage"))
);
// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
	path: "/",
	children: [
		{
			path: "/",
			element: (
				<AuthGuard>
					<MainLayout />
				</AuthGuard>
			),
			children: [
				{
					index: true,
					path: "/",
					element: <DashboardPage />,
				},
				{
					path: "orders",
					element: <OrdersPage />,
				},
				{
					path: "mimic-settings",
					element: <MimicSettingsPage />,
				},
				{
					path: "connect-admin",
					element: <ConnectAdmin />,
				},
				{
					path: "instruments",
					element: <InstrumentsPage />,
				},
			],
		},
		{
			path: "/maintenance",
			element: <CommonLayout />,
			children: [
				{
					path: "404",
					element: <MaintenanceError />,
				},
				{
					path: "500",
					element: <MaintenanceError500 />,
				},
				{
					path: "under-construction",
					element: <MaintenanceUnderConstruction />,
				},
			],
		},
	],
};

export default MainRoutes;
